module.exports = __webpack_public_path__ + "img/抢光了.7c3227aa.png";